"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _QueryTrace_wasForceClosed, _QueryTrace_fnClose, _QueryTrace_fnProgress, _Query_instances, _Query_tracing, _Query_leaveOpen, _Query_cancelAt, _Query_checkTrace, _Query_feed, _Query_log, _Query_onProgress, _Query_stopCheckTraces, _Query_checkTraces, _Query_canSendQuery, _Query_sendQueryInternal;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
const uuid_1 = require("uuid");
const debug_1 = __importDefault(require("debug"));
const shared_1 = require("@snort/shared");
const _1 = require(".");
const utils_1 = require("./utils");
const request_merger_1 = require("./request-merger");
const request_expander_1 = require("./request-expander");
/**
 * Tracing for relay query status
 */
class QueryTrace {
    constructor(relay, filters, connId, fnClose, fnProgress) {
        this.relay = relay;
        this.filters = filters;
        this.connId = connId;
        _QueryTrace_wasForceClosed.set(this, false);
        _QueryTrace_fnClose.set(this, void 0);
        _QueryTrace_fnProgress.set(this, void 0);
        this.id = (0, uuid_1.v4)();
        this.start = (0, shared_1.unixNowMs)();
        __classPrivateFieldSet(this, _QueryTrace_fnClose, fnClose, "f");
        __classPrivateFieldSet(this, _QueryTrace_fnProgress, fnProgress, "f");
    }
    sentToRelay() {
        this.sent = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    gotEose() {
        this.eose = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    forceEose() {
        this.eose = (0, shared_1.unixNowMs)();
        __classPrivateFieldSet(this, _QueryTrace_wasForceClosed, true, "f");
        this.sendClose();
    }
    sendClose() {
        this.close = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnClose, "f").call(this, this.id);
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    /**
     * Time spent in queue
     */
    get queued() {
        return (this.sent === undefined ? (0, shared_1.unixNowMs)() : __classPrivateFieldGet(this, _QueryTrace_wasForceClosed, "f") ? (0, shared_1.unwrap)(this.eose) : this.sent) - this.start;
    }
    /**
     * Total query runtime
     */
    get runtime() {
        return (this.eose === undefined ? (0, shared_1.unixNowMs)() : this.eose) - this.start;
    }
    /**
     * Total time spent waiting for relay to respond
     */
    get responseTime() {
        return this.finished ? (0, shared_1.unwrap)(this.eose) - (0, shared_1.unwrap)(this.sent) : 0;
    }
    /**
     * If tracing is finished, we got EOSE or timeout
     */
    get finished() {
        return this.eose !== undefined;
    }
}
_QueryTrace_wasForceClosed = new WeakMap(), _QueryTrace_fnClose = new WeakMap(), _QueryTrace_fnProgress = new WeakMap();
/**
 * Active or queued query on the system
 */
class Query {
    constructor(id, instance, feed, leaveOpen) {
        _Query_instances.add(this);
        /**
         * Which relays this query has already been executed on
         */
        _Query_tracing.set(this, []);
        /**
         * Leave the query open until its removed
         */
        _Query_leaveOpen.set(this, false);
        /**
         * Time when this query can be removed
         */
        _Query_cancelAt.set(this, void 0);
        /**
         * Timer used to track tracing status
         */
        _Query_checkTrace.set(this, void 0);
        /**
         * Feed object which collects events
         */
        _Query_feed.set(this, void 0);
        _Query_log.set(this, (0, debug_1.default)("Query"));
        this.id = id;
        __classPrivateFieldSet(this, _Query_feed, feed, "f");
        this.fromInstance = instance;
        __classPrivateFieldSet(this, _Query_leaveOpen, leaveOpen ?? false, "f");
        __classPrivateFieldGet(this, _Query_instances, "m", _Query_checkTraces).call(this);
    }
    isOpen() {
        return __classPrivateFieldGet(this, _Query_cancelAt, "f") === undefined && __classPrivateFieldGet(this, _Query_leaveOpen, "f");
    }
    canRemove() {
        return __classPrivateFieldGet(this, _Query_cancelAt, "f") !== undefined && __classPrivateFieldGet(this, _Query_cancelAt, "f") < (0, shared_1.unixNowMs)();
    }
    /**
     * Recompute the complete set of compressed filters from all query traces
     */
    get filters() {
        return (0, request_merger_1.flatMerge)(this.flatFilters);
    }
    get flatFilters() {
        const f = [];
        for (const x of __classPrivateFieldGet(this, _Query_tracing, "f").flatMap(a => a.filters)) {
            if (!f.some(a => (0, utils_1.reqFilterEq)(a, x))) {
                f.push(x);
            }
        }
        return f.flatMap(request_expander_1.expandFilter);
    }
    get feed() {
        return __classPrivateFieldGet(this, _Query_feed, "f");
    }
    onEvent(sub, e) {
        for (const t of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            if (t.id === sub) {
                this.feed.add(e);
                break;
            }
        }
    }
    /**
     * This function should be called when this Query object and FeedStore is no longer needed
     */
    cancel() {
        __classPrivateFieldSet(this, _Query_cancelAt, (0, shared_1.unixNowMs)() + 5000, "f");
    }
    uncancel() {
        __classPrivateFieldSet(this, _Query_cancelAt, undefined, "f");
    }
    cleanup() {
        __classPrivateFieldGet(this, _Query_instances, "m", _Query_stopCheckTraces).call(this);
    }
    sendToRelay(c, subq) {
        if (!__classPrivateFieldGet(this, _Query_instances, "m", _Query_canSendQuery).call(this, c, subq)) {
            return;
        }
        return __classPrivateFieldGet(this, _Query_instances, "m", _Query_sendQueryInternal).call(this, c, subq);
    }
    connectionLost(id) {
        __classPrivateFieldGet(this, _Query_tracing, "f").filter(a => a.connId == id).forEach(a => a.forceEose());
    }
    connectionRestored(c) {
        if (this.isOpen()) {
            for (const qt of __classPrivateFieldGet(this, _Query_tracing, "f")) {
                if (qt.relay === c.Address) {
                    debugger;
                    c.QueueReq(["REQ", qt.id, ...qt.filters], () => qt.sentToRelay());
                }
            }
        }
    }
    sendClose() {
        for (const qt of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            qt.sendClose();
        }
        this.cleanup();
    }
    eose(sub, conn) {
        const qt = __classPrivateFieldGet(this, _Query_tracing, "f").find(a => a.id === sub && a.connId === conn.Id);
        qt?.gotEose();
        if (!__classPrivateFieldGet(this, _Query_leaveOpen, "f")) {
            qt?.sendClose();
        }
    }
    /**
     * Get the progress to EOSE, can be used to determine when we should load more content
     */
    get progress() {
        const thisProgress = __classPrivateFieldGet(this, _Query_tracing, "f").reduce((acc, v) => (acc += v.finished ? 1 : 0), 0) / __classPrivateFieldGet(this, _Query_tracing, "f").length;
        if (isNaN(thisProgress)) {
            return 0;
        }
        return thisProgress;
    }
}
exports.Query = Query;
_Query_tracing = new WeakMap(), _Query_leaveOpen = new WeakMap(), _Query_cancelAt = new WeakMap(), _Query_checkTrace = new WeakMap(), _Query_feed = new WeakMap(), _Query_log = new WeakMap(), _Query_instances = new WeakSet(), _Query_onProgress = function _Query_onProgress() {
    const isFinished = this.progress === 1;
    if (this.feed.loading !== isFinished) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "%s loading=%s, progress=%d", this.id, this.feed.loading, this.progress);
        this.feed.loading = isFinished;
    }
}, _Query_stopCheckTraces = function _Query_stopCheckTraces() {
    if (__classPrivateFieldGet(this, _Query_checkTrace, "f")) {
        clearInterval(__classPrivateFieldGet(this, _Query_checkTrace, "f"));
    }
}, _Query_checkTraces = function _Query_checkTraces() {
    __classPrivateFieldGet(this, _Query_instances, "m", _Query_stopCheckTraces).call(this);
    __classPrivateFieldSet(this, _Query_checkTrace, setInterval(() => {
        for (const v of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            if (v.runtime > 5000 && !v.finished) {
                v.forceEose();
            }
        }
    }, 500), "f");
}, _Query_canSendQuery = function _Query_canSendQuery(c, q) {
    if (q.relay && q.relay !== c.Address) {
        return false;
    }
    if (!q.relay && c.Ephemeral) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "Cant send non-specific REQ to ephemeral connection %O %O %O", q, q.relay, c);
        return false;
    }
    if (q.filters.some(a => a.search) && !c.SupportsNip(_1.Nips.Search)) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "Cant send REQ to non-search relay", c.Address);
        return false;
    }
    return true;
}, _Query_sendQueryInternal = function _Query_sendQueryInternal(c, q) {
    const qt = new QueryTrace(c.Address, q.filters, c.Id, x => c.CloseReq(x), () => __classPrivateFieldGet(this, _Query_instances, "m", _Query_onProgress).call(this));
    __classPrivateFieldGet(this, _Query_tracing, "f").push(qt);
    c.QueueReq(["REQ", qt.id, ...qt.filters], () => qt.sentToRelay());
    return qt;
};
//# sourceMappingURL=data:application/json;base64,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